export const getLineItemsByStatus = (lineItems, status) => {
  return lineItems?.filter(lineItem => {
    if (lineItem.newStatus) {
      return lineItem.newStatus === status
    }
    return lineItem.status === status
  })
}
